import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { Adviser } from '../../Models/Domains/Adviser/Adviser';

declare var IS_RUNNING_IN_APP_POOL;

export class AdvisersClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(company: string, network: string, currentPage: number, resultsPerPage: number, readWriteAccessOnly: boolean): Promise<ResultPageModel<Adviser>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/Advisers/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { company: company, network: network, currentPage: currentPage, resultsPerPage: resultsPerPage, readWriteAccessOnly: readWriteAccessOnly }

    return AjaxWrapper.get<ResultPageModel<Adviser>, any>(url, data);
  }
}

